import React from 'react';
import ReactDOM from 'react-dom/client';
import { useThemeMode } from 'shared/utils/theme';
import { ThemeProvider } from '@superdispatch/ui';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { App } from './App';
import { FormsProvider } from '@superdispatch/forms';
import { getFormErrors } from './FormErrors';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false, retryOnMount: false } },
});

function ThemeWrapper() {
  const [themeMode] = useThemeMode();

  return (
    <ThemeProvider mode={themeMode}>
      <FormsProvider getFormErrors={getFormErrors}>
        <App />
      </FormsProvider>
    </ThemeProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeWrapper />
    </QueryClientProvider>
  </React.StrictMode>,
);
